import { useContext } from 'react';
import { Breadcrumb, Checkbox, Page, Row } from '../../components';
import { SettingsContext } from '../../context/SettingsContext';
import './SettingsPage.scss';
import { AuthContext } from '../../context';
import { Button } from '@mui/material';

export const SettingsPage = () => {
    const { logout } = useContext(AuthContext);
    const { 
        updateSetting, 
        darkMode,
        showClassFilter,
        showSchoolFilter,
        showLevelFilter,
        showSourceFilter,
        showComponentFilter,
        showDamageTypeFilter,
        showTagsFilter,
        showSaveFilter,
        showAttackFilter,
        showCastingTimeFilter,
        includeSubclasses
    } = useContext(SettingsContext);

    return (
        <Page className="SettingsPage">
            <Breadcrumb />
            <Row><h3>General</h3></Row>
            <Row onClick={() => updateSetting('darkMode', !darkMode)}>
                <Checkbox 
                    checked={darkMode}
                />
                Enable Dark Mode
            </Row>
            <Row onClick={() => updateSetting('includeSubclasses', !includeSubclasses)}>
                <Checkbox 
                    checked={includeSubclasses}
                />
                Include Sub-classes in class lists and filters
            </Row>
            <hr />
            <Row><h3>Filters</h3></Row>
            <Row onClick={() => updateSetting('showClassFilter', !showClassFilter)}>
                <Checkbox 
                    checked={showClassFilter}
                />
                Class
            </Row>
            <Row onClick={() => updateSetting('showSchoolFilter', !showSchoolFilter)}>
                <Checkbox 
                    checked={showSchoolFilter}
                />
                School
            </Row>
            <Row onClick={() => updateSetting('showLevelFilter', !showLevelFilter)}>
                <Checkbox 
                    checked={showLevelFilter}
                />
                Level
            </Row>
            <Row onClick={() => updateSetting('showSourceFilter', !showSourceFilter)}>
                <Checkbox 
                    checked={showSourceFilter}
                />
                Source
            </Row>
            <Row onClick={() => updateSetting('showComponentFilter', !showComponentFilter)}>
                <Checkbox 
                    checked={showComponentFilter}
                />
                Components
            </Row>
            <Row onClick={() => updateSetting('showDamageTypeFilter', !showDamageTypeFilter)}>
                <Checkbox 
                    checked={showDamageTypeFilter}
                />
                Damage Type
            </Row>
            <Row onClick={() => updateSetting('showTagsFilter', !showTagsFilter)}>
                <Checkbox 
                    checked={showTagsFilter}
                />
                Tags
            </Row>
            <Row onClick={() => updateSetting('showSaveFilter', !showSaveFilter)}>
                <Checkbox 
                    checked={showSaveFilter}
                />
                Saving throw
            </Row>
            <Row onClick={() => updateSetting('showAttackFilter', !showAttackFilter)}>
                <Checkbox 
                    checked={showAttackFilter}
                />
                Spell attack
            </Row>
            <Row onClick={() => updateSetting('showCastingTimeFilter', !showCastingTimeFilter)}>
                <Checkbox 
                    checked={showCastingTimeFilter}
                />
                Spell attack
            </Row>
            <hr />
            <Row className='center'>
                <Button variant='contained' color='secondary' onClick={() => logout()}>
                    Sign out
                </Button>
            </Row>
        </Page>
    );
};